(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (() => {
  const elementName = 'toni-country-announcement';

  if (!('customElements' in window) || customElements.get(elementName)) {
    return;
  }

  class ToniCountryAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.country = (this.dataset.country || 'FI').toUpperCase();
      this.language = this.normalizeLanguage(this.dataset.language || 'en');
      this.isEu = this.dataset.isEu === 'true';
      this.shippingSupported = this.dataset.shippingSupported === 'true';

      this.warehouseTimeZone =
        this.dataset.warehouseTimeZone || 'Europe/Helsinki';

      const parsedCutoffHour = Number(this.dataset.cutoffHour || 13);

      this.cutoffHour = Number.isFinite(parsedCutoffHour)
        ? parsedCutoffHour
        : 13;

      this.currentIndex = 0;
      this.closedDatesByYear = new Map();

      this.reduceMotion = window
        .matchMedia('(prefers-reduced-motion: reduce)')
        .matches;

      this.messages = this.buildMessages();

      this.renderCurrentMessage();
      this.scheduleRotation();

      this.refreshTimer = window.setInterval(
        () => this.refreshMessages(),
        30000
      );

      this.onPageShow = () => {
        this.refreshMessages();
      };

      this.onVisibilityChange = () => {
        if (!document.hidden) {
          this.refreshMessages();
        }
      };

      window.addEventListener(
        'pageshow',
        this.onPageShow
      );

      document.addEventListener(
        'visibilitychange',
        this.onVisibilityChange
      );
    }

    disconnectedCallback() {
      window.clearTimeout(this.rotationTimer);
      window.clearTimeout(this.fadeTimer);
      window.clearInterval(this.refreshTimer);

      if (this.onPageShow) {
        window.removeEventListener(
          'pageshow',
          this.onPageShow
        );
      }

      if (this.onVisibilityChange) {
        document.removeEventListener(
          'visibilitychange',
          this.onVisibilityChange
        );
      }

      this.initialized = false;
    }

    normalizeLanguage(language) {
      const shortCode = String(language)
        .toLowerCase()
        .slice(0, 2);

      return ['fi', 'de', 'en'].includes(shortCode)
        ? shortCode
        : 'en';
    }

    getCopy() {
      const copy = {
        fi: {
          today: (time) =>
            `Tilaa klo ${time} mennessä – lähetämme tänään.`,

          benefits: {
            fi: 'Nopeat toimitukset kotimaasta.',
            eu: 'Express-toimitus ulkomaille saatavilla.',
            other: 'Express-toimitus ulkomaille saatavilla.'
          },

          secondary: {
            fi: 'Suomalainen pyöräilyn erikoiskauppa.',
            eu: 'Suomalainen pyöräilyn erikoiskauppa.',
            other: 'Suomalainen pyöräilyn erikoiskauppa.'
          }
        },

        de: {
          today: (time) =>
            `Bis ${time} bestellen – wir versenden noch heute.`,

          benefits: {
            fi: 'Schneller Versand aus Finnland.',
            eu: 'Expressversand verfügbar.',
            other: 'Expressversand verfügbar.'
          },

          secondary: {
            fi: 'Ihr Radsport-Spezialist aus Finnland.',
            eu: 'Ihr Radsport-Spezialist aus Finnland.',
            other: 'Ihr Radsport-Spezialist aus Finnland.'
          }
        },

        en: {
          today: (time) =>
            `Order by ${time} – we’ll ship today.`,

          benefits: {
            fi: 'Fast shipping from Finland.',
            eu: 'Express shipping available.',
            other: 'Express shipping available.'
          },

          secondary: {
            fi: 'Your Finnish cycling specialist.',
            eu: 'Your Finnish cycling specialist.',
            other: 'Your Finnish cycling specialist.'
          }
        }
      };

      return copy[this.language] || copy.en;
    }

    getMarketType() {
      if (this.country === 'FI') {
        return 'fi';
      }

      if (this.isEu) {
        return 'eu';
      }

      return 'other';
    }

    buildMessages() {
      const copy = this.getCopy();
      const marketType = this.getMarketType();

      if (!this.shippingSupported) {
        return [copy.secondary[marketType]];
      }

      const dispatchState = this.getDispatchState();
      const benefit = copy.benefits[marketType];

      if (dispatchState.canDispatchToday) {
        return [
          copy.today(dispatchState.localCutoffTime),
          benefit
        ];
      }

      return [
        benefit,
        copy.secondary[marketType]
      ];
    }

    getDispatchState() {
      const now = new Date();

      const warehouseParts = this.getZonedParts(
        now,
        this.warehouseTimeZone
      );

      const warehouseDate = new Date(
        Date.UTC(
          Number(warehouseParts.year),
          Number(warehouseParts.month) - 1,
          Number(warehouseParts.day)
        )
      );

      const secondsNow =
        Number(warehouseParts.hour) * 3600 +
        Number(warehouseParts.minute) * 60 +
        Number(warehouseParts.second);

      const cutoffSeconds =
        this.cutoffHour * 3600;

      const canDispatchToday =
        this.isFinnishDispatchDate(warehouseDate) &&
        secondsNow < cutoffSeconds;

      if (!canDispatchToday) {
        return {
          canDispatchToday: false,
          localCutoffTime: ''
        };
      }

      const cutoffInstant = new Date(
        now.getTime() +
        (cutoffSeconds - secondsNow) * 1000
      );

      return {
        canDispatchToday: true,
        localCutoffTime:
          this.formatCustomerTime(cutoffInstant)
      };
    }

    getCountryTimeZone() {
      const timeZones = {
        FI: 'Europe/Helsinki',
        AT: 'Europe/Vienna',
        BE: 'Europe/Brussels',
        DK: 'Europe/Copenhagen',
        EE: 'Europe/Tallinn',
        FR: 'Europe/Paris',
        DE: 'Europe/Berlin',
        IT: 'Europe/Rome',
        LV: 'Europe/Riga',
        LT: 'Europe/Vilnius',
        LU: 'Europe/Luxembourg',
        NL: 'Europe/Amsterdam',
        PL: 'Europe/Warsaw',
        SI: 'Europe/Ljubljana',
        SE: 'Europe/Stockholm'
      };

      return timeZones[this.country] || null;
    }

    formatCustomerTime(date) {
      const countryTimeZone = this.getCountryTimeZone();

      const parts = this.partsToObject(
        new Intl.DateTimeFormat(
          'en-GB',
          {
            timeZone: countryTimeZone || this.warehouseTimeZone,
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
          }
        ).formatToParts(date)
      );

      const hour = String(
        Number(parts.hour)
      );

      const minute =
        parts.minute || '00';

      let formattedTime;

      if (this.language === 'fi') {
        formattedTime = minute === '00'
          ? hour
          : `${hour}.${minute}`;
      } else if (this.language === 'de') {
        formattedTime = minute === '00'
          ? `${hour} Uhr`
          : `${hour}:${minute} Uhr`;
      } else {
        formattedTime = `${hour.padStart(2, '0')}:${minute}`;
      }

      if (countryTimeZone) {
        return formattedTime;
      }

      const timeZoneLabels = {
        fi: 'Suomen aikaa',
        de: 'finnischer Zeit',
        en: 'Finnish time'
      };

      return `${formattedTime} (${timeZoneLabels[this.language] || timeZoneLabels.en})`;
    }

    getZonedParts(date, timeZone) {
      return this.partsToObject(
        new Intl.DateTimeFormat(
          'en-GB',
          {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
          }
        ).formatToParts(date)
      );
    }

    partsToObject(parts) {
      return parts.reduce(
        (result, part) => {
          if (part.type !== 'literal') {
            result[part.type] =
              part.value;
          }

          return result;
        },
        {}
      );
    }

    refreshMessages() {
      const previousMessage =
        this.messages?.[this.currentIndex];

      this.messages =
        this.buildMessages();

      if (
        this.currentIndex >=
        this.messages.length
      ) {
        this.currentIndex = 0;
      }

      if (
        this.messages[this.currentIndex] !==
        previousMessage
      ) {
        this.renderCurrentMessage();
      }
    }

    scheduleRotation() {
      window.clearTimeout(
        this.rotationTimer
      );

      if (this.messages.length < 2) return;

      const duration =
        this.currentIndex === 0
          ? 6000
          : 4000;

      this.rotationTimer =
        window.setTimeout(
          () => this.rotateMessage(),
          duration
        );
    }

    rotateMessage() {
      this.currentIndex =
        (
          this.currentIndex + 1
        ) % this.messages.length;

      if (this.reduceMotion) {
        this.renderCurrentMessage();
        this.scheduleRotation();
        return;
      }

      this.classList.add(
        'is-changing'
      );

      this.fadeTimer =
        window.setTimeout(
          () => {
            this.renderCurrentMessage();

            this.classList.remove(
              'is-changing'
            );

            this.scheduleRotation();
          },
          180
        );
    }

    renderCurrentMessage() {
      const message =
        this.messages[this.currentIndex];

      this.textContent =
        message;

      this.syncAccessibleText(
        message
      );
    }

    syncAccessibleText(message) {
      const slide =
        this.closest(
          'slideshow-slide'
        );

      const hiddenText =
        slide?.querySelector(
          '[data-toni-announcement-hidden]'
        );

      if (hiddenText) {
        hiddenText.textContent =
          message;
      }
    }

    isFinnishDispatchDate(date) {
      const weekday =
        date.getUTCDay();

      if (
        weekday === 0 ||
        weekday === 6
      ) {
        return false;
      }

      const year =
        date.getUTCFullYear();

      return !this
        .getFinnishClosedDates(year)
        .has(
          this.getUtcDateKey(date)
        );
    }

    getFinnishClosedDates(year) {
      if (
        this.closedDatesByYear.has(year)
      ) {
        return this
          .closedDatesByYear
          .get(year);
      }

      const fixedDate = (
        month,
        day
      ) =>
        [
          year,
          String(month).padStart(
            2,
            '0'
          ),
          String(day).padStart(
            2,
            '0'
          )
        ].join('-');

      const closedDates =
        new Set([
          fixedDate(1, 1),
          fixedDate(1, 6),
          fixedDate(5, 1),
          fixedDate(12, 6),
          fixedDate(12, 24),
          fixedDate(12, 25),
          fixedDate(12, 26)
        ]);

      const easterSunday =
        this.getEasterSundayUtc(year);

      closedDates.add(
        this.getUtcDateKey(
          this.addUtcDays(
            easterSunday,
            -2
          )
        )
      );

      closedDates.add(
        this.getUtcDateKey(
          this.addUtcDays(
            easterSunday,
            1
          )
        )
      );

      closedDates.add(
        this.getUtcDateKey(
          this.addUtcDays(
            easterSunday,
            39
          )
        )
      );

      for (
        let day = 19;
        day <= 25;
        day += 1
      ) {
        const midsummerEve =
          new Date(
            Date.UTC(
              year,
              5,
              day
            )
          );

        if (
          midsummerEve.getUTCDay() === 5
        ) {
          closedDates.add(
            this.getUtcDateKey(
              midsummerEve
            )
          );

          break;
        }
      }

      this.closedDatesByYear.set(
        year,
        closedDates
      );

      return closedDates;
    }

    getEasterSundayUtc(year) {
      const a =
        year % 19;

      const b =
        Math.floor(year / 100);

      const c =
        year % 100;

      const d =
        Math.floor(b / 4);

      const e =
        b % 4;

      const f =
        Math.floor((b + 8) / 25);

      const g =
        Math.floor(
          (b - f + 1) / 3
        );

      const h =
        (
          19 * a +
          b -
          d -
          g +
          15
        ) % 30;

      const i =
        Math.floor(c / 4);

      const k =
        c % 4;

      const l =
        (
          32 +
          2 * e +
          2 * i -
          h -
          k
        ) % 7;

      const m =
        Math.floor(
          (
            a +
            11 * h +
            22 * l
          ) / 451
        );

      const month =
        Math.floor(
          (
            h +
            l -
            7 * m +
            114
          ) / 31
        );

      const day =
        (
          (
            h +
            l -
            7 * m +
            114
          ) % 31
        ) + 1;

      return new Date(
        Date.UTC(
          year,
          month - 1,
          day
        )
      );
    }

    addUtcDays(date, days) {
      const result =
        new Date(
          date.getTime()
        );

      result.setUTCDate(
        result.getUTCDate() +
        days
      );

      return result;
    }

    getUtcDateKey(date) {
      return [
        date.getUTCFullYear(),

        String(
          date.getUTCMonth() + 1
        ).padStart(
          2,
          '0'
        ),

        String(
          date.getUTCDate()
        ).padStart(
          2,
          '0'
        )
      ].join('-');
    }
  }

  customElements.define(
    elementName,
    ToniCountryAnnouncement
  );
})();
  } catch(e) { console.error(e); }
})();

})();
